__turbopack_context__.v({
  "icon": "theme-toggle-module__Rg0A6W__icon",
  "keoLogo": "theme-toggle-module__Rg0A6W__keoLogo",
  "pulse": "theme-toggle-module__Rg0A6W__pulse",
  "selectContent": "theme-toggle-module__Rg0A6W__selectContent",
  "selectItem": "theme-toggle-module__Rg0A6W__selectItem",
  "selectItemIndicator": "theme-toggle-module__Rg0A6W__selectItemIndicator",
  "selectTrigger": "theme-toggle-module__Rg0A6W__selectTrigger",
  "selectViewport": "theme-toggle-module__Rg0A6W__selectViewport",
  "span": "theme-toggle-module__Rg0A6W__span",
  "toggleContainer": "theme-toggle-module__Rg0A6W__toggleContainer",
  "toggleGroup": "theme-toggle-module__Rg0A6W__toggleGroup",
  "toggleGroupIcon": "theme-toggle-module__Rg0A6W__toggleGroupIcon",
  "toggleGroupItem": "theme-toggle-module__Rg0A6W__toggleGroupItem",
  "toggleGroupItemActive": "theme-toggle-module__Rg0A6W__toggleGroupItemActive",
  "toggleGroupWrapper": "theme-toggle-module__Rg0A6W__toggleGroupWrapper",
  "toggleSkeleton": "theme-toggle-module__Rg0A6W__toggleSkeleton",
});
